import { ICareerHubNavigationService } from '@careerhub/common';
import { DialogSubmitHandler, careerHubSdk } from '@careerhub/hub-sdk';

export class CareerHubNavigationService implements ICareerHubNavigationService {
  constructor() {}

  /**
   * Launch Profile Modal
   * @param userId: string - userId
   * @param submitHandler: modal callback handler.
   * @returns profileWindow: IAppWindow
   */
  launchProfile = (userId?: string, submitHandler?: DialogSubmitHandler) => {
    const profileWindow = careerHubSdk.startTask(
      {
        title: 'Profile',
        url: `${window.location.origin}/profile?userId=${userId || ''}`,
        size: {
          height: 1000,
          width: 843,
        },
      },
      submitHandler
    );
    return profileWindow;
  };
}
